import middle from '../../middlewares/api/middle'

export const GET_YEARS = 'YEARS/GET'

export const getYears = () => middle(GET_YEARS, {
    api: '/api',
    url: '/years'
})
